import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};

  ${props =>
    props.isActive &&
    css`
      border-radius: ${props => props.theme.primitives.radius.radius2};
      padding: ${props => props.theme.spacing.sp16};
      background-color: ${props => props.theme.colors.background.secondary};
    `}
`

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
